// Initialize Osano pre-load interface
(function (w, o, d) {
  w[o] =
    w[o] ||
    function () {
      w[o][d].push(arguments);
    };
  w[o][d] = w[o][d] || [];
})(window, 'Osano', 'data');

// Function to check if "osano-test=true" is in the URL parameters
function isOsanoTestParam() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('osano-test') === 'true';
}

// Wait for Osano to initialize
Osano.cm.addEventListener('osano-cm-initialized', () => {
  // Create a Promise to handle location check and Osano initialization
  const osanoInitPromise = new Promise(async (resolve, reject) => {
    try {
      // Check for test parameter or perform jurisdiction-based logic
      if (isOsanoTestParam()) {
        console.log('osano-test param detected. Displaying consent banner.');
        pollForOsanoBanner();
        resolve(true);
      } else {
        // Check session storage first
        const storedJurisdiction = sessionStorage.getItem('userJurisdiction');
        let jurisdiction;

        if (storedJurisdiction) {
          jurisdiction = storedJurisdiction;
          console.log('Retrieved jurisdiction from session storage:', jurisdiction);
        } else {
          // Get user's jurisdiction
          jurisdiction = window.Osano.cm.jurisdiction;
          console.log('Retrieved jurisdiction from Osano:', jurisdiction);

          // Store in session storage for future use
          if (jurisdiction) {
            sessionStorage.setItem('userJurisdiction', jurisdiction);
          }
        }

        // Check jurisdiction-specific conditions
        if (jurisdiction) {
          const regionString = window.osano_zones;
          const allowedRegions = regionString.split(', ').map((item) => item.trim());

          if (allowedRegions.includes(jurisdiction)) {
            console.log('Displaying consent banner.');
            pollForOsanoBanner();
            resolve(true);
          } else {
            console.log('Consent banner blocked due to region.');
            Osano.cm.hideDialog();
            resolve(false);
          }
        } else {
          console.log('Unable to determine jurisdiction. Hiding banner.');
          Osano.cm.hideDialog();
          resolve(false);
        }
      }
    } catch (error) {
      console.error('Error in Osano initialization:', error);
      reject(error);
    }
  });

  // Function to check and show the Osano banner with polling
  function pollForOsanoBanner(maxAttempts = 50, interval = 500) {
    let attempts = 0;
    const checker = setInterval(() => {
      attempts++;
      const osanoDialog = document.querySelector('.osano-cm-dialog');
      if (osanoDialog) {
        osanoDialog.style.display = 'flex';
        clearInterval(checker);
        console.log('Osano dialog found and displayed');
        return;
      }
      if (attempts >= maxAttempts) {
        clearInterval(checker);
        console.log('Osano dialog not found after maximum attempts');
      }
    }, interval);
  }

  // Export the promise for other scripts to use
  window.osanoReady = osanoInitPromise;
});
